var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkspace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 130.63 124.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#505050;}.cls-2{fill:#9ca5ad;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "114.71 124.12 15.92 124.12 15.92 36.17 65.32 0.61 114.71 36.17 114.71 124.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M114.71,124.73H15.92a.6.6,0,0,1-.6-.61V36.17a.58.58,0,0,1,.25-.49L65,.12a.62.62,0,0,1,.71,0l49.39,35.56a.6.6,0,0,1,.25.49v88A.6.6,0,0,1,114.71,124.73Zm-98.19-1.21h97.59v-87L65.32,1.35,16.52,36.48Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.32 0.61 65.32 0.61 65.31 0.6 65.31 0.6 0.6 47.2 4 51.91 65.31 7.76 65.32 0.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M4,52.52H3.9a.6.6,0,0,1-.39-.24L.11,47.55a.61.61,0,0,1,.14-.84L65,.11a.6.6,0,0,1,.63,0,.59.59,0,0,1,.31.38.6.6,0,0,1-.16.58l-.12.1L1.45,47.34l2.69,3.73L65,7.27a.61.61,0,0,1,.84.14.59.59,0,0,1-.13.84L4.35,52.4A.57.57,0,0,1,4,52.52Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "65.31 0.6 65.32 0.61 130.03 47.2 126.63 51.91 65.31 7.76 65.31 0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.63,52.52a.57.57,0,0,1-.35-.12L65,8.25a.59.59,0,0,1-.13-.84.61.61,0,0,1,.84-.14l60.82,43.8,2.69-3.73L65,1.1A.46.46,0,0,1,64.89,1a.59.59,0,0,1,0-.85.59.59,0,0,1,.79,0l64.7,46.58a.56.56,0,0,1,.24.39.6.6,0,0,1-.1.45l-3.4,4.72a.6.6,0,0,1-.39.24Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.47,
    y: 62.93,
    width: 37.69,
    height: 61.79
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspace);
export default __webpack_public_path__ + "static/media/workspace.a2c8587fb3483b9e66c34bc00a5f7344.svg";
export { ForwardRef as ReactComponent };